import { Modal } from 'Components'

import type { WheelItemsData, WheelItem } from '../wheelData'

import DetailedDescriptionContent from './DetailedDescriptionContent'

type EmotionDialogProps = {
  activeItem: WheelItem | null
  wheelItemsData: WheelItemsData
  isOpen: boolean
  onClose: () => void
}

export default function EmotionDialog({
  isOpen,
  activeItem,
  wheelItemsData,
  onClose,
}: EmotionDialogProps) {
  if (!isOpen || !activeItem) return null
  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <DetailedDescriptionContent item={activeItem} wheelItemsData={wheelItemsData} />
    </Modal>
  )
}
